import { useAppDispatch } from "src/common/state/hooks";
import type { AppDispatch } from "src/common/state/store";
import { closeStandardModal, openStandardModal } from "src/common/state/slice/modal/modalSlice";
import { setMediaSearch } from "src/features/gallery/state/gallerySlice";
import ModalGallery from "src/features/graph/components/ModalGallery";
import type { IMedia } from "src/model/unityObject";

export const openReferenceImageGallery = (dispatch: AppDispatch) => {
  dispatch(setMediaSearch({ mediaType: "image", media360tag: "", query: "", page: 0 }));
  dispatch(openStandardModal("modal-gallery"));
};

interface ReferenceImageGalleryHostProps {
  /** ModalGallery is hard-wired to the "modal-gallery" modal id, so only ONE
   * instance may be mounted at a time or every open renders twice. The host
   * therefore mounts its instance only while its own picking session is
   * active — callers flip this before calling openReferenceImageGallery. */
  open: boolean;
  onPicked: (media: IMedia) => void;
  onClosed: () => void;
}

const ReferenceImageGalleryHost = ({
  open,
  onPicked,
  onClosed,
}: ReferenceImageGalleryHostProps) => {
  const dispatch = useAppDispatch();
  if (!open) return null;
  return (
    <ModalGallery
      nodeId="profile"
      allowedMediaTypeOverride="image"
      onMediaChange={(media: IMedia) => {
        dispatch(closeStandardModal("modal-gallery"));
        onClosed();
        onPicked(media);
      }}
      onCancel={() => {
        dispatch(closeStandardModal("modal-gallery"));
        onClosed();
      }}
    />
  );
};

export default ReferenceImageGalleryHost;
